import PropTypes from 'prop-types'
import { isMobile } from 'react-device-detect'
import Background from 'components/_ui/Background'
import styles from './AppBackground.module.scss'

AppBackground.propTypes = {
  mobileSrc: PropTypes.string,
  src: PropTypes.string,
  srcSet: PropTypes.string,
  mobileSrcSet: PropTypes.string
}

export default function AppBackground ({ src, mobileSrc, srcSet, mobileSrcSet }) {
  return (
    <Background
      className={ styles.container }
      src={ isMobile ? mobileSrc : src }
      srcSet={ isMobile ? mobileSrcSet : srcSet }
      fetchpriority="high"
      duration={ 0.75 } />
  )
}
